import { render } from "./MobileLayout.vue?vue&type=template&id=5e11cffc&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=5e11cffc&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e11cffc"]])

export default __exports__